import HelpdeskGraphQL from "./HelpdeskGraphQL";
import axios from "./Axios";
import {HELPDESK_SERVICE_URL} from "../config";

class Customer extends HelpdeskGraphQL {
    static async getCustomerData(personId) {
        return await axios()({
            url: HELPDESK_SERVICE_URL + '/cstmr/'+personId,
            method: 'GET',
        });
    }

    static async createConvExternalHelpdesk(payload) {
        return await axios()({
            url: HELPDESK_SERVICE_URL + '/external-helpdesk/conversation',
            method: 'POST',
            data: {
                payload
            }
        });
    }
}
export default Customer
